













import Vue from "vue";
import { required, integer } from "vuelidate/lib/validators";
import dialog from "@/common/mixins/dialog";
import ShipnityEditorForm from "../components/ShipnityEditorForm.vue";
import { ShipnityCreateForm } from "../forms/ShipnityCreateForm";
import { Shop } from "../../shop/models/Shop";
export default Vue.extend({
  mixins: [dialog],
  components: {
    ShipnityEditorForm
  },
  validations: {
    shipnityCreateForm: {
      shop: { required },
      shopName: { required },
      email: { required },
      token: { required },
      mcApiKey: { required },
      mcSecretkey: { required },
      stockIdValue: { integer }
    }
  },
  data() {
    const shops: Shop[] = [];
    const shipnityCreateForm: ShipnityCreateForm = {
      shopName: "",
      email: "",
      token: "",
      mcApiKey: "",
      mcSecretkey: ""
    };
    return { shipnityCreateForm, shops };
  },
  async created() {
    await Promise.all([this.getShops()]);
  },
  methods: {
    async getShops() {
      try {
        const { data } = await (this as any).$dep.shopUseCase.getShops({
          perPage: 9999
        });
        this.shops = data;
      } catch (error) {
        console.log(error.response);
      }
    },
    goToShipnityViewPage() {
      this.$router.push({ name: "ShipnityViewPage" });
    },
    async createShipnity() {
      try {
        await (this as any).$dep.shipnityUseCase.createShopShipnity(
          this.shipnityCreateForm
        );
        if (
          await (this as any).alertSuccess("Success", "เพิ่ม Shipnity สำเร็จ")
        ) {
          this.goToShipnityViewPage();
        }
      } catch (error) {
        if (error.response && error.response.status === 400) {
          (this as any).alertError("Error", error.response.data.message);
        } else {
          process.env.NODE_ENV === "production"
            ? (this as any).alertError("Error", "ไม่สามารถสร้าง Shipnity ได้")
            : (this as any).alertError("Error", error);
        }
      }
    },
    async submit() {
      this.$v.$touch();
      if (this.$v.$invalid) return;

      const isConfirmed = await (this as any).alertConfirm(
        "Confirm to add Shipnity",
        "คุณต้องการเพิ่ม Shipnity หรือไม่ ?"
      );
      if (isConfirmed) {
        await this.createShipnity();
      }
    },
    clear() {
      this.$v.$reset();
      this.shipnityCreateForm = {
        shopName: "",
        email: "",
        token: "",
        mcApiKey: "",
        mcSecretkey: ""
      };
    }
  }
});
